import $ from 'jquery';
$(document).ready(function() {
    $(function() {
        const Accordion = function(el, multiple) {
            this.el = el || {};
            this.multiple = multiple || false;

            // Variables privadas
            var links = this.el.find('.link');
            // Evento
            links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown)
        };

        Accordion.prototype.dropdown = function(e) {
            const $el = e.data.el;
            // eslint-disable-next-line no-undef
            $this = $(this),
                // eslint-disable-next-line no-undef
                $next = $this.next();

            // eslint-disable-next-line no-undef
            $next.slideToggle();
            // eslint-disable-next-line no-undef
            $this.parent().toggleClass('open');

            if (!e.data.multiple) {
                // eslint-disable-next-line no-undef
                $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
            }
        };

        // eslint-disable-next-line no-unused-vars
        const accordion = new Accordion($('#accordion'), false);

    });

});